import React from 'react';
import { Button } from '@/components/ui/button';
import { MinusIcon, PlusIcon } from 'lucide-react'; // Assuming you use lucide-react for icons

interface StepperInputProps {
  value: number;
  onChange: (value: number) => void;
  min?: number;
  max?: number;
  className?: string;
  id?: string;
}

export const StepperInput: React.FC<StepperInputProps> = ({
  value,
  onChange,
  min = 1, // Default min value
  max,
  className = '',
  id,
}) => {
  const handleIncrement = () => {
    if (max === undefined || value < max) {
      onChange(value + 1);
    }
  };

  const handleDecrement = () => {
    if (value > min) {
      onChange(value - 1);
    }
  };

  return (
    <div className={`flex items-center space-x-2 ${className}`} id={id}>
      <Button
        type="button" // Prevent form submission
        variant="outline"
        size="icon"
        className="h-10 w-10 sm:h-11 sm:w-11 bg-black/50 border-white/10 hover:bg-white/10 disabled:opacity-50 disabled:cursor-not-allowed"
        onClick={handleDecrement}
        disabled={value <= min}
        aria-label="Decrease quantity"
      >
        <MinusIcon className="h-4 w-4 sm:h-5 sm:w-5 text-white/80" />
      </Button>
      <div className="flex-1 text-center text-sm sm:text-base font-medium bg-black/50 border border-white/10 rounded-lg px-3 py-2 h-10 sm:h-11 flex items-center justify-center">
        {value}
      </div>
      <Button
        type="button" // Prevent form submission
        variant="outline"
        size="icon"
        className="h-10 w-10 sm:h-11 sm:w-11 bg-black/50 border-white/10 hover:bg-white/10 disabled:opacity-50 disabled:cursor-not-allowed"
        onClick={handleIncrement}
        disabled={max !== undefined && value >= max}
        aria-label="Increase quantity"
      >
        <PlusIcon className="h-4 w-4 sm:h-5 sm:w-5 text-white/80" />
      </Button>
    </div>
  );
}; 